import $ from "jquery";

const init = () => {
  observeElement();
  categoryOnClick();
};

const observeElement = () => {
  if (!$(".mi-product-overview").length) return;

  const btn = document.querySelector(".wpf-search-container");
  const options = {
    attributes: true,
  };

  // eslint-disable-next-line no-unused-vars
  function callback(mutationList, observer) {
    // eslint-disable-line
    mutationList.forEach(function (mutation) {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "class"
      ) {
        // handle class change
        changeText();
        const highlighted = `[for='${$(".custom-filter-title").attr(
          "selectedcategoryid"
        )}']`;

        $("label").removeAttr("style");

        const highlightedSelector = $(highlighted);
        highlightedSelector.css("color", "#046e94");
        highlightedSelector.css("font-weight", "600");
      }
    });
  }

  const observer = new MutationObserver(callback);
  observer.observe(btn, options);
};

const changeText = () => {
  if (!$(".category-name").length) return;
  const category = $(".custom-filter-title").attr("selectedCategory");
  if (!category) return;
  const newStr = category.replaceAll("-", " ");
  $(".category-name").text(newStr);
};

const categoryOnClick = () => {
  $(".wpf_hierachy label").on("click", (e) => {
    $(".custom-filter-title").attr("selectedCategory", $(e.target).text());
    $(".custom-filter-title").attr(
      "selectedCategoryId",
      $(e.target).attr("for")
    );
  });
};

try {
  init();
} catch (error) {
  console.warn(error);
}
